import { IdentitiesScreen } from '@/components/identities-view/IdentitiesScreen';

export function IdentitiesPage() {
  return <IdentitiesScreen />;
}
